import { useEffect } from "react";

/*
 * Adds `is-visible` to every `.lp-reveal` inside the page once it scrolls into
 * view. One shared IntersectionObserver keeps this cheap regardless of how many
 * elements opt in. Elements already on-screen at mount reveal immediately.
 */
export function useScrollReveal() {
  useEffect(() => {
    const targets = document.querySelectorAll(".lp-reveal");
    if (!targets.length) return;

    // No IntersectionObserver (or reduce-motion) → show everything up front.
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (prefersReduced || typeof IntersectionObserver === "undefined") {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" },
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}
